import type { components } from '~/api/openapi';

export type Permission = components['schemas']['Permission'];
export type AccountType = components['schemas']['UserDto']['accountType'];

export function hasPermission(
  permissions: Permission[] | undefined,
  permission: Permission
): boolean {
  return permissions?.includes(permission) ?? false;
}

export function isCreatorLike(accountType: AccountType | undefined): boolean {
  return accountType === 'CREATOR' || accountType === 'EDITOR';
}

// Whether the token can read the org/team catalogue (GET /v1/companies).
// company:admin is CREATOR's transitional grant; company:view is the revived
// read permission vega-api plans for facilitators — pre-wired here so the
// catalogue surfaces (journey settings picker, submission filter dropdowns)
// light up without a frontend change when the backend grants it. Must mirror
// the endpoint's gate: both sides of a grant + re-gate ship together.
export function canReadCompanyCatalogue(permissions: Permission[] | undefined): boolean {
  return hasPermission(permissions, 'company:admin') || hasPermission(permissions, 'company:view');
}
